export default __webpack_public_path__ + "static/char-10-anr-57a119452e717d6c47d4b80698460f27.gif";